// src/lib/utils/currency.ts
// All monetary values flow through this. R prefix, en-ZA locale, two decimals.
// Negative inputs render with a leading minus before the currency symbol.

export const formatRand = (amount: number): string => {
  const isNegative = amount < 0;
  const abs = Math.abs(amount);
  const formatted = abs.toLocaleString('en-ZA', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${isNegative ? '-' : ''}R ${formatted}`;
};

// Tabular variant — no fraction digits stripped, fixed-width thousand sep.
// Use inside <table> cells with `font-variant-numeric: tabular-nums`.
export const formatRandTabular = (amount: number): string => formatRand(amount);
